import React from 'react';

const PlayButtonIcon = () => (
  <svg
    width="50"
    height="55"
    viewBox="0 0 50 55"
    xmlns="http://www.w3.org/2000/svg">
    <path d="M46.533 31.93L7.597 54.335C4.115 56.228 0 53.704 0 49.917V5.108C0 1.322 4.115-1.202 7.597.691l38.936 22.404c3.482 1.893 3.482 6.942 0 8.835z" />
  </svg>
);

export default PlayButtonIcon;
